export const formatarMoeda = (valor: number): string =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);

export const formatarPercentual = (valor: number, casasDecimais = 0): string =>
  `${valor.toFixed(casasDecimais)}%`;

export const formatarData = (isoDate: string): string => {
  // Aceita tanto "AAAA-MM-DD" quanto um DateTime ISO completo ("AAAA-MM-DDTHH:mm:ss") — vários
  // campos do backend (ex.: MaestroHoliday.Data) serializam como DateTime mesmo carregando só a
  // parte da data, e um split ingênuo por "-" quebrava o "T..." dentro do dia.
  const [ano, mes, dia] = isoDate.split('T')[0].split('-');
  if (!ano || !mes || !dia) return isoDate;
  return `${dia}/${mes}/${ano}`;
};

export const formatarDataHora = (isoDateTime: string): string => {
  const [data, hora] = isoDateTime.split('T');
  return hora ? `${formatarData(data)} ${hora.slice(0, 5)}` : formatarData(data);
};

export const formatarCompetencia = (competencia: string): string => competencia;

export const iniciais = (nome: string): string =>
  nome
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(parte => parte[0]?.toUpperCase())
    .join('');
